import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Role, useUserQuery } from './api/gql';
import { FullPageLoader } from './components';
import { AppLayout } from './layout';
import { AdminLayout } from './layout/app/AdminLayout';
import { notify } from './utils/notification';

export const ClientRootComponent = () => {
  const { data, isLoading, error } = useUserQuery(undefined, {
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  useLogUserQueryError(error);

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (!data) {
    return <Navigate to={'/error'} />;
  }

  return <AppLayout />;
};

export const AdminRootComponent = () => {
  const { data, isLoading, error } = useUserQuery(undefined, {
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  useLogUserQueryError(error);

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (!data) {
    return <Navigate to={'/error'} />;
  }

  if (data.user.role === Role.User) {
    notify.negative({
      message: 'Chyba autorizace. Admin sekce Vám není přístupná.',
    });
    return <Navigate to={'/'} />;
  }

  return <AdminLayout />;
};

const useLogUserQueryError = (error: unknown) => {
  useEffect(() => {
    if (error) {
      console.error('Failed to fetch user:', error);
    }
  }, [error]);
};
